module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="has-login-bg"></div>\n<div class="has-login-box">\n    <span class="company-name">' +
((__t = ( distributorAccount.distrbName )) == null ? '' : __t) +
'</span>\n    <div class="user-name-status">\n        <div class="status1 clearfix">\n            <span class="user-name">' +
((__t = ( user.customerUserName )) == null ? '' : __t) +
'</span>\n            <p class="user-status">\n                ';
 if (user.station != '请选择'){ ;
__p += '\n                (' +
((__t = ( user.station )) == null ? '' : __t) +
')\n                ';
 } ;
__p += '\n            </p>\n        </div>\n        <div class="status2 clearfix">\n            <p class="user-balance">余额：<span class="balance-acount">￥' +
((__t = ( distributorAccount.balance )) == null ? '' : __t) +
'</span></p>\n            <!--<a href="/charge/userCharge.do?chargeType=charge" class="recharge" data-track="企业首页_登录框_快速充值">快速充值&gt;</a>-->\n            <a href="/pay/toPayOrCharge.do?payMethod=0" class="recharge" data-track="企业首页_登录框_快速充值">快速充值&gt;</a>\n        </div>\n    </div>\n    <a href="/user/bookHotel.do" class="go-fzg" data-track="企业首页_登录框_进入房掌柜">进入房掌柜</a>\n    <a class="login-out" href="javascript:void(0)" data-track="企业首页_退出登录">退出登录</a>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/firstPage/templates/hasLogin.ejs
// module id = 297
// module chunks = 48